import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import cloneDeep from 'lodash/cloneDeep';
import { useMemo } from 'react';

import { useFormattedData } from './useFormattedData';

import type { TotalActionsPerOrganizationItem } from '@/app/types/Dashboard';
import './style.css';

interface CustomSeriesOptions extends Highcharts.Options {
	itemTotal?: number;
}

interface Props {
	data: TotalActionsPerOrganizationItem[];
	ascending?: boolean;
}

const ChartTotalActions = ({ ascending = true, data }: Props) => {
	const options = useFormattedData(data);

	const sortedOptions = useMemo(() => {
		if (options?.series && Array.isArray(options?.series)) {
			const deepClonedOptions = cloneDeep(options);
			const sortData = {
				...deepClonedOptions,
				series: (deepClonedOptions.series as CustomSeriesOptions[]).sort((a, b) => {
					return ascending
						? (a.itemTotal ?? 0) - (b.itemTotal ?? 0)
						: (b.itemTotal ?? 0) - (a.itemTotal ?? 0);
				}),
			};
			return sortData;
		}
	}, [ascending, options]);

	return <HighchartsReact options={sortedOptions} highcharts={Highcharts} />;
};

export default ChartTotalActions;
